import { Tags } from '@dehaat/kisan-app-bl/models/PostsV2';
import { useEffect } from 'react';
import { POST_TYPE } from '@/constants/posts';
import useBlogComments from '@/hooks/useBlogComments';
import { BlogComment } from '@/models/Posts';
import scrollBarStyles from '@/styles/HideScrollbar.module.css';
import BlogCommentsList from './BlogCommentsList';
import CommentsBar from './CommentsBar';
export interface Props {
  postId: number;
  postType: POST_TYPE;
  addComment: VoidFunction;
  postCreator?: string;
  tags?: Tags[] | null;
}
const CommentSectionModal = ({
  addComment,
  postId,
  postType,
  postCreator,
  tags
}: Props) => {
  const {
    fetchNext,
    loading: commentsLoading,
    loadingNext,
    comments,
    nextPageUrl,
    error,
    fetchNewComment
  } = useBlogComments(postId);
  const handleCommentsCallback = (comment: BlogComment) => {
    addComment();
    fetchNewComment(comment);
  };
  useEffect(() => {
    const commentBar = document.getElementById('comment-bar');
    if (commentBar) {
      commentBar.focus();
    }
  }, []);
  return <div className="absolute top-0 w-full h-screen p-4 bg-white pb-28 z-10" data-sentry-component="CommentSectionModal" data-sentry-source-file="CommentsSectionModal.tsx">
      <div className={`max-w-4xl mx-auto max-h-[85vh] overflow-y-scroll pt-18 ${scrollBarStyles.scroll}`}>
        <BlogCommentsList id={postId} comments={comments} loading={commentsLoading} loadingNext={loadingNext} nextPageUrl={nextPageUrl} error={error} fetchNext={fetchNext} postCreator={postCreator} tags={tags} data-sentry-element="BlogCommentsList" data-sentry-source-file="CommentsSectionModal.tsx" />
        <div className="fixed bottom-0 left-0 mx-1 w-webkit-fill">
          <CommentsBar id={postId} postType={postType} postCreator={postCreator} tags={tags} callback={handleCommentsCallback} data-sentry-element="CommentsBar" data-sentry-source-file="CommentsSectionModal.tsx" />
        </div>
      </div>
    </div>;
};
export default CommentSectionModal;